import FooterSitemap from './FooterSitemap';
export default FooterSitemap;
